export default [
  {
    path: '/calendar/child/add',
    name: 'calendar-child-add',
    component: () => import('@/modules/calender/add/addChildData'),

  },
  {
    path: '/calendar/child/list',
    name: 'calendar-child-list',
    component: () => import('@/modules/calender/list/listChild'),
  },
  {
    path: '/calendar/category/list',
    name: 'calendar-category-list',
    component: () => import('@/modules/calender/list/listCategory')
  },
  {
    path: '/calendar/mother/list',
    name: 'calendar-mother-list',
    component: () => import('@/modules/calender/users/listMothers')
  },
  {
    path: '/calendar/children/list',
    name: 'calendar-children-list',
    component: () => import('@/modules/calender/users/listBabies')
  },
  {
    path: '/calendar/babyInfo/:id/:unit',
    name: 'calendar-babyInfo-list',
    component: () => import('@/modules/calender/users/babyInfo')
  },
]
